import { PencilNewIcon, TrashIcon } from "components/icons";

import cn from "lib/cn";

import { TTabeField, TTableRecord } from "../../types";

export interface FieldDeleteUpdateProps {
  field?: TTabeField;
  record?: TTableRecord;
}

const FieldDeleteUpdate = ({ field, record }: FieldDeleteUpdateProps) => {
  const handleClickUpdate = (e: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();

    if (field?.onClickUpdate) {
      field?.onClickUpdate(record);
    }
  };

  const handleClickDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();

    if (field?.onClickDelete) {
      field?.onClickDelete(record);
    }
  };

  return (
    <div className={cn(field?.className)}>
      <div className="flex items-center justify-start gap-3">
        <button
          className={cn(
            "w-[2rem] h-[2rem] flex items-center justify-center",
            record?.[field?.hideKey] ? field?.editClassName : undefined
          )}
          onClick={handleClickUpdate}
        >
          <PencilNewIcon width={17} height={17} />
        </button>
        {record?.[field?.hideKey] ? null : (
          <button
            className="w-[2rem] text-red-500 h-[2rem] flex items-center justify-center"
            onClick={handleClickDelete}
          >
            <TrashIcon width={17} height={17} />
          </button>
        )}
      </div>
    </div>
  );
};

export default FieldDeleteUpdate;
